export const SDK_VERSION = '1.8.5';
